import Factory from '../factory';
import {Collection, Schema} from "@oilstone/rest-model-repository";

const schema = Factory.schema('hero-carousel-2');
const attributes = schema.getProp('attributes').getValue();
const item = new Schema();

item.prop('category').setType(String).setValue('Category');
item.prop('heading').setType(String).setValue('Heading');
item.prop('text').setType(String).setValue('Text...');
item.prop('stat').setType(String).setValue('Stat');
item.prop('statText').setType(String).setValue('Stat text');
item.prop('btnText').setType(String).setValue('Find out more');
item.prop('imgSrc').setType(String).setValue('image-placeholder-square.svg');

attributes.prop('items').setType(Collection).setValue(new Collection(item));

export default schema;
